<template>   
<div class="login-tab">     <h2>绑定手机号</h2>     <Password :login-type="'binding'" @success="success" />   
</div> </template>

<script>
import Password from '../../my/components/password.vue'
export default {
  components: { Password },
  data() {
    return {}
  },
  methods: {
    success() {}
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 24px;
  color: #333333;
  font-weight: 600;
}
</style>
